import { Typography } from 'antd'
import { CIMSTabs } from 'components/CIMSTabs'
import { useState } from 'react'
import DesignLayerTab from './components/DesignLayerTab'
import { DesignLayerOption, useDesignLayers } from './hooks/useDesignLayers'
import CIMSLink from '../../../../../../../components/CIMSLink'
import { useGlobalState } from '../../../../../../../context/GlobalStateContext'

const DesignLayers: React.FC = () => {
  const {
    state: { projectGlobalId },
  } = useGlobalState()
  const [currentTab, setCurrentTab] = useState<DesignLayerOption>(
    DesignLayerOption.AsphaltMaterials
  )
  const { loading } = useDesignLayers(currentTab)
  const tabs = Object.values(DesignLayerOption).map((tab) => {
    return {
      key: tab.name,
      label: tab.name,
      disabled: loading,
      component: (tab: DesignLayerOption['name']) => {
        const found = Object.values(DesignLayerOption).find(
          ({ name }) => name === tab
        )
        setCurrentTab(found!)
        return <DesignLayerTab {...found!} />
      },
    }
  })
  return (
    <CIMSTabs
      prefix={
        <>
          <Typography.Text>
            Many PDF Reports generate a composite image composed of satellite
            imagery, project specific feature layers, and feature geometries
            specific to the report.
          </Typography.Text>
          <Typography.Text>
            Configure which project specific feature layers to show for each
            option and its associated values below.
          </Typography.Text>
          <Typography.Text>
            A{' '}
            <CIMSLink
              to={`/${projectGlobalId}/administration/project-settings`}
            >
              CM Project Layer
            </CIMSLink>{' '}
            must be set for the Project to configure PDF Design Layers.
          </Typography.Text>
        </>
      }
      sort
      initialTab={currentTab.name}
      tabs={tabs}
    />
  )
}

export default DesignLayers
